module.exports = __webpack_public_path__ + "img/message.f21637ac.svg";